const components = [
  {
    title: "图片",
    tag: "de-image",
    props: [
      {
        title: "图片",
        name: "image",
        type: {
          name: "image"
        },
        default:""
      },
      {
        title: "图像宽度",
        name: "width",
        type: {
          name: "number-unit",
          options: {
            units: [
              {
                value: "px",
                label: "像素"
              },
              {
                value: "%",
                label: "百分比"
              }
            ]
          }
        },
        default:{
            value:100, unit:'%'
        }
      },
      {
        title: "图像高度",
        name: "height",
        type: {
            name: "number-unit",
            options: {
              units: [
                {
                  value: "px",
                  label: "像素"
                },
                {
                  value: "%",
                  label: "百分比"
                }
              ]
            }
          },
          default:{
            value:100, unit:'%'
        }
      },
      {
        title: "重复",
        name: "repeat",
        type: {
          name: "select1",
          options: {
            options: [
              {
                value: "no-repeat",
                label: "不重复"
              },
              {
                value: "repeat",
                label: "XY轴都重复"
              },
              {
                value: "repeat-x",
                label: "X轴重复"
              },
              {
                value: "repeat-y",
                label: "Y轴重复"
              }
            ]
          }
        }
      }
    ]
  },
  {
    title: "定时器",
    tag: "de-timer",
    props:[
      {
        name:'cronExpression',
        title:'cron表达式',
        type: {
          name: "text"
        },
        default:""
      }
    ],
    events:[
      {
        name:'on-tick',
        title:'定时事件',
      }
    ]
  },
  {
    title: 'iframe',
    tag: 'de-iframe',
    group:'layout',
    eventHandlers:[
        {
            name: 'updateIframeLink',
            title: '更新iframe地址'
        }
    ],
    props: [
        {
            name: 'link',
            title: '链接',
            type: {
                name: 'text'
            },
            default: ''
        },
        {
            name: 'width',
            title: '高度',
            type: {
                name: 'number'
            },
            default: 100
        },
        {
            name: 'height',
            title: '宽度',
            type: {
                name: 'number'
            },
            default: 100
        }
    ]
  },
  {
    title: "微信分享",
    tag: "de-share-wechat",
    defaultSize:{
			width: 60, 
			height: 60
		},
    props:[
      {
        name:'title',
        title:'标题',
        type: {
          name: "text"
        },
        default:""
      },
      {
        name:'desc',
        title:'描述',
        type: {
          name: "text"
        },
        default:""
      },
      {
        name:'link',
        title:'链接',
        type: {
          name: "text"
        },
        default:""
      },
      {
        name:'imgUrl',
        title:'图标',
        type: {
          name: "image"
        },
        default:""
      },
      {
        name:'isDebug',
        title:'开启调试',
        type: {
          name: "bool"
        },
        default:false
      }
    ],
  }
];
export { components };
